import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import FarmLoader from './FarmLoader'

type LoadingProps = {
  open?: boolean
  label?: string
  // Renderiza dentro da área da página, sem overlay: sidebar, topo e indicador de
  // sync continuam acessíveis durante carregamentos longos.
  inline?: boolean
}

const Loading = ({ open = false, label, inline = false }: LoadingProps) => {
  if (!open) return null

  const labelProps = label ? { label } : {}

  if (inline) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: 200,
        }}
      >
        <FarmLoader {...labelProps} labelColor='#666' />
      </div>
    )
  }

  return (
    <div
      style={{
        zIndex: 100000,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    >
      <Backdrop open sx={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}>
        <FarmLoader {...labelProps} />
      </Backdrop>
    </div>
  )
}

export default Loading
